import { Component, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/pages/base/base.component';
import { HeaderService } from 'src/app/services/_app/header/header.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent extends BaseComponent implements OnDestroy {
  isInViewMode: boolean = false;
  isShowSavedViews: boolean = false;
  savedViews: Array<any> = [];
  private isInViewModeSubscription: Subscription;
  private isShowSavedViewsSubscription: Subscription;
  private savedViewsSubscription: Subscription;
  searchOverlayVisible: boolean = false;
  isCreateAuditDialog: boolean = false;
  sidebarVisible: boolean = false;
  hasSavedViews: boolean = true;
  savedViewsCount: number = 0;
  isAlertModal: boolean = false;
  savedViewData: any;
  items: MenuItem[] = [
    {
      label: 'See full data report',
      icon: 'pi pi-eye',
    },
    {
      label: 'Backup DB',
      icon: 'pi pi-cloud-upload',
    },
    {
      label: 'Delete Audit',
      icon: 'pi pi-trash'
    }
  ];

  parentId: string = "search-input-id";
  public viewName: string = 'View Mode';

  constructor(private _headerService: HeaderService) {
    super();
    this.isInViewModeSubscription = this._headerService.isInViewMode$.subscribe(isInViewMode => {
      this.isInViewMode = isInViewMode;
    });
    this.isShowSavedViewsSubscription = this._headerService.isShowSavedViews$.subscribe(isShowSavedViewsSubscription => {
      this.isShowSavedViews = isShowSavedViewsSubscription;

      if (this.isShowSavedViews) {
        this.showSavedViews();
      }

    });
    this.savedViewsSubscription = this._headerService.savedViews$.subscribe(savedViewsSubscription => {
      console.log("savedViews", savedViewsSubscription);
      this.savedViews = savedViewsSubscription;
      this.savedViews.map((x) => {
        x.TableCount = x.Tables2?.length;
      });

      this.savedViewsCount = this.savedViews.length;
    });
  }

  searchOnFocus() {
    setTimeout(() => {
      let all = document.getElementsByClassName('p-overlaypanel-content');

      console.log("ngDoCheck", all)
      let targetElement = this.getFirstElementWithNoId(all);
      if (targetElement) {
        targetElement.id = this.parentId + '-abc';

        let parent = document.getElementById(this.parentId);
        parent?.appendChild(targetElement);
      }
    }, 200)
  }

  searchOnBlur() {
    let element = document.getElementById('search-input-id-abc');

    element?.remove();
  }

  openMenu(menu: any, event: any) {
    menu.toggle(event);
  }

  getFirstElementWithNoId(elements: HTMLCollection): Element | null {
    for (let i = 0; i < elements.length; i++) {
      const element = elements.item(i);
      if (element && !element.id) return element;
    }
    return null;
  }

  openCreateAuditModal(event: any) {
    this.isCreateAuditDialog = true;
  }

  dialogCloseEmitter(event: boolean) {
    this.isCreateAuditDialog = event;
  }

  //temp for view UI
  showSavedViews() {
    this.sidebarVisible = !this.sidebarVisible;
    this.hasSavedViews = !this.hasSavedViews;

    setTimeout(() => {
      this.hasSavedViews = !this.hasSavedViews;
    }, 30)
  }

  loadView(savedView: any) {
    // this._headerService.setSpinner(true);
    this.sidebarVisible = false;

    this._headerService.loadSavedView(savedView);

    this.viewName = `View: ${savedView.ViewName}`;
  }

  deleteSavedView(savedView: any) {
    this._headerService.deleteSavedView(savedView);
  }

  //open alert modal
  deleteAuditProfileAlert(savedView: any) {
    this.savedViewData = savedView
    this.isAlertModal = true;
  }
  //handling alert modal
  handleAlertModal(res: any) {
    if (!res.isDelete) { this.isAlertModal = res?.isModalVisibility }
    else {
      this.deleteSavedView(this.savedViewData);
      this.isAlertModal = res?.isModalVisibility;
    }
  }

  gotoStripe() {
    window.open('https://billing.stripe.com/p/login/eVa3eZ4EDbsQb849AA', '_blank');
  }

  logout() {
    //TODO: call logout API
    // remove everything from the local storage
    localStorage.clear();
    // redirect to login page
    window.location.href = '/';
  }

  closeViewMode() {
    //this.isInViewMode = false;
    this._headerService.updateIsInViewMode(false);
  }

  ngOnDestroy(): void {
    this.isInViewModeSubscription.unsubscribe();
    this.isShowSavedViewsSubscription.unsubscribe();
    this.savedViewsSubscription.unsubscribe();
  }
}
